// @flow

export async function delay (ms: number): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, ms))
}
